import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import Reviewer from './Reviewer'

function Review({ review, openFullReviewModal }) {
  const maxReviewLength = 140

  function formatLongReview() {
    return (
      <Fragment>
        {review.content.substr(0, maxReviewLength)}
        ... <span className="link--primary-dark read-more-link" onClick={() => openFullReviewModal(review)}>Read more</span>
      </Fragment>
    )
  }

  return (
    <div className="card review">
      <div className="l-inner-large">
        <Reviewer name={review.name} rating={review.rating} avatar={review.avatar.large_url} />
        <h3 className="review__title">{review.title}</h3>
        <p className="review__content">
          {review.content.length > maxReviewLength ? formatLongReview() : review.content}
        </p>
      </div>
    </div>
  )
}

Review.propTypes = {
  review: PropTypes.shape({
    name: PropTypes.string.isRequired,
    rating: PropTypes.number.isRequired,
    avatar: PropTypes.object,
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
  }).isRequired,
  openFullReviewModal: PropTypes.func.isRequired,
}

export default Review
